<div class="clsWrapping" style="margin-bottom: 130px;">
  <div class="signUpPage">
    W.O.W Sign Up
  </div>
  <div class="host-signup-banner" *ngIf="asHost">
    You’re applying to become a host. After you create your account and sign in, you’ll continue to host signup.
    Host approval is required before you can start uploading listings on the site.
  </div>
  <form [formGroup]="form" autocomplete="nope">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <mat-form-field class="clsGapping">
            <mat-label>E-mail</mat-label>
            <input matInput type="email" formControlName="EmailId" placeholder="Ex. pat@example.com" required>
            <mat-error
              *ngIf="!form.controls['EmailId'].valid && form.controls['EmailId'].touched && form.controls['EmailId'].errors.required">
              Email is required.
            </mat-error>
            <mat-error
              *ngIf="!form.controls['EmailId'].valid && form.controls['EmailId'].touched && form.controls['EmailId'].errors.email">
              Invalid email format.
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field class="clsGapping">
            <mat-label>Phone Number</mat-label>
            <input matInput formControlName="phoneNumber" placeholder="Phone Number" required numbersonlyChecker
              maxlength="10" minlength="10">
            <mat-error *ngIf="form.controls['phoneNumber'].hasError('required')">PhoneNumber is required</mat-error>
            <mat-error *ngIf="form.controls.phoneNumber.hasError('minlength')">Allowed length is 10 digits (without country code).</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <mat-form-field class="clsGapping">
            <mat-label>First Name</mat-label>
            <input matInput formControlName="FirstName" placeholder="First Name" required humanNamesChecker>
            <mat-error *ngIf="form.controls['FirstName'].invalid">First Name is required</mat-error>
          </mat-form-field>
        </div>

        <div class="col-md-6">
          <mat-form-field class="clsGapping">
            <mat-label>Last Name</mat-label>
            <input matInput formControlName="LastName" placeholder="Last Name" required humanNamesChecker>
            <mat-error *ngIf="form.controls['LastName'].invalid">Last Name is required</mat-error>
          </mat-form-field>
        </div>
      </div>


      <div class="cols-m-12 col-md-12 col-lg-12">
        <div class="row">
          <div class="cols-m-12 col-md-12 col-lg-12" style="font-weight: bold; margin-bottom: 10px;">
            Billing Address
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <mat-form-field class="clsGapping">
              <mat-label>Street Address</mat-label>
              <input matInput formControlName="Address" placeholder="Street  Address" required>
              <mat-error *ngIf="form.controls['Address'].hasError('required')">Address is required</mat-error>
              <mat-error *ngIf="form.controls['Address'].hasError('minlength')">Provide valid Street Address (min 5 characters).</mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field class="clsGapping">
              <mat-label>City</mat-label>
              <input matInput formControlName="city" placeholder="City" required appCityValidator>
              <mat-error *ngIf="form.controls['city'].hasError('required')">City is required</mat-error>
              <mat-error *ngIf="form.controls['city'].hasError('minlength')">Provide valid City (min 3 characters).</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <mat-form-field class="clsGapping">
              <mat-label>State</mat-label>
              <mat-select formControlName="state" placeholder="State" required
                style="font-family: Arial, Helvetica, sans-serif;" required>
                <mat-option>None</mat-option>
                <mat-option *ngFor="let state of statelist" value="{{state.name}}">{{state.name}}</mat-option>
              </mat-select>
              <mat-error *ngIf="form.controls['state'].invalid">State is required</mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field class="clsGapping">
              <mat-label>Zip Code</mat-label>
              <input matInput formControlName="zipCode" placeholder="Zip Code" maxlength="5" required
                numbersonlyChecker appNumbersonlyNotStartingFromZero>
              <mat-error *ngIf="form.controls['zipCode'].hasError('required')">Zip Code is required</mat-error>
              <mat-error *ngIf="form.controls['zipCode'].hasError('minlength')">Zip Code min length is 5.</mat-error>
              <mat-error *ngIf="form.controls['zipCode'].hasError('maxlength')">Zip Code max length is 10.</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <button mat-raised-button color="primary" type="button" (click)="validateBillingAddress()" 
                    [disabled]="isValidatingBillingAddress || !form.controls['Address'].value || !form.controls['city'].value || !form.controls['state'].value || !form.controls['zipCode'].value">
              <span *ngIf="!isValidatingBillingAddress">Validate Billing Address</span>
              <span *ngIf="isValidatingBillingAddress">Validating...</span>
            </button>
            <div *ngIf="billingAddressValidation && billingAddressValidation.success && billingAddressValidation.isValid" 
                 style="color: green; margin-top: 5px; font-size: 12px;">
              ✓ Address validated successfully
            </div>
            <div *ngIf="billingAddressValidation && billingAddressValidation.dpvDescription" 
                 style="color: orange; margin-top: 5px; font-size: 12px;">
              {{ billingAddressValidation.dpvDescription }}
            </div>
          </div>
        </div>
      </div>

      <div class="cols-m-12 col-md-12 col-lg-12">
        <div class="row">
          <div class="cols-m-12 col-md-12 col-lg-12" style="font-weight: bold;">
            Shipping Address
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <mat-checkbox class="clsGapping" formControlName="ShipingAsBilling"
              style="font-family: Verdana, Geneva, Tahoma, sans-serif;" (change)="onChangeShippingAsBilling()">Shipping
              same as billing
            </mat-checkbox>
          </div>
        </div>
        <div>
          <div class="row">
            <div class="col-md-6">
              <mat-form-field class="clsGapping">
                <mat-label>Street Address</mat-label>
                <input matInput formControlName="ShipingStreetAddress" placeholder="Street  Address" required>
                <mat-error *ngIf="form.controls['ShipingStreetAddress'].hasError('required')">Address is required</mat-error>
                <mat-error *ngIf="form.controls['ShipingStreetAddress'].hasError('minlength')">Provide valid Street Address (min 5 characters).</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field class="clsGapping">
                <mat-label>City</mat-label>
                <input matInput formControlName="ShipingCity" placeholder="City" required appCityValidator>
                <mat-error *ngIf="form.controls['ShipingCity'].hasError('required')">City is required</mat-error>
                <mat-error *ngIf="form.controls['ShipingCity'].hasError('minlength')">Provide valid City (min 3 characters).</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <mat-form-field class="clsGapping">
                <mat-label>State</mat-label>
                <mat-select formControlName="ShipingState" placeholder="State" required
                  style="font-family: Arial, Helvetica, sans-serif;" required>
                  <mat-option>None</mat-option>
                  <mat-option *ngFor="let state of statelist" value="{{state.name}}">{{state.name}}</mat-option>
                </mat-select>
                <mat-error *ngIf="form.controls['ShipingState'].invalid">State is required</mat-error>
              </mat-form-field>
            </div>

            <div class="col-md-6">
              <mat-form-field class="clsGapping">
                <mat-label>Zip Code</mat-label>
                <input matInput formControlName="ShipingZipCode" placeholder="Zip Code" maxlength="5" required
                  numbersonlyChecker appNumbersonlyNotStartingFromZero>
                <mat-error *ngIf="form.controls['ShipingZipCode'].hasError('required')">Zip Code is required</mat-error>
                <mat-error *ngIf="form.controls['ShipingZipCode'].hasError('minlength')">Zip Code min length is
                  5.</mat-error>
                <mat-error *ngIf="form.controls['ShipingZipCode'].hasError('maxlength')">Zip Code max length is
                  10.</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <mat-form-field class="clsGapping">
            <mat-label>Password</mat-label>
            <input [type]="hidePw ? 'password' : 'text'" type="password" matInput formControlName="password"
              placeholder="Password" required>
            <mat-icon matSuffix (click)="hidePw = !hidePw" [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hidePw" style="cursor: pointer;">
              {{hidePw ? 'visibility_off' : 'visibility'}}
            </mat-icon>
            <mat-error *ngIf="form.controls['password'].errors?.required">Password is required</mat-error>
            <mat-error *ngIf="form.controls['password'].errors?.pattern">Please choose strong password</mat-error>
          </mat-form-field>
        </div>

        <div class="col-md-6">
          <mat-form-field class="clsGapping">
            <mat-label>Confirm Password</mat-label>
            <input [type]="hideConfirmPw ? 'password' : 'text'" matInput type="password"
              formControlName="confirmPassword" placeholder="Confirm Password" required>
            <mat-icon matSuffix (click)="hideConfirmPw = !hideConfirmPw" [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hideConfirmPw" style="cursor: pointer;">
              {{hideConfirmPw ? 'visibility_off' : 'visibility'}}
            </mat-icon>
            <mat-error
              *ngIf="form.controls['confirmPassword'].pristine || form.controls['confirmPassword'].errors?.MatchPassword">
              Password does not match</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div *ngIf="!isMobileView">
            <mat-checkbox class="clsGapping" formControlName="isNotificationEnabled"
              (change)="onChangeNotificationEnabled($event)"
              style="font-family: Verdana, Geneva, Tahoma, sans-serif;"> Notifications for new products.
            </mat-checkbox>

            <div class="row" *ngIf="form.controls['isNotificationEnabled'].value">
              <div class="col-md-6" style="margin-left: 30px;">
                <mat-checkbox formControlName="isPhone" (change)="onNotificationPreferenceChange()"> Phone</mat-checkbox>

                <mat-checkbox formControlName="isEmail" style="margin-left: 20px;" (change)="onNotificationPreferenceChange()"> Email </mat-checkbox>
              </div>
              <div class="col-md-6">
              </div>
            </div>
            <mat-checkbox class="clsGapping" style="font-family: Verdana, Geneva, Tahoma, sans-serif;"
              formControlName="isGetNotifiedWhenVideoGoesLive">Get notified when your purchased video webinar goes
              live.
            </mat-checkbox>
            <mat-checkbox class="clsGapping" style="font-family: Verdana, Geneva, Tahoma, sans-serif;"
              formControlName="isAcceptTermsConditions">* I understand and accept all the <a
                routerLink="/TermConditions" style="color: blue !important;">Terms and
                Conditions</a> of this site. </mat-checkbox>
          </div>
        </div>
        <div class="col-md-6">
          <div style="margin-left: 10px; font-size: 18px; color: #9e3249; margin-bottom: 5px;">
            Password Requirements:
          </div>
          <div class="password-hint">
            <small>
              *Minimum length of 8 & maximum 30 characters.<br />
              *Minimum 1 special character. <br />
              *Minimum 1 uppercase letter. <br />
              *Minimum 1 lowercase letter. <br />
              *Minimum 1 number. <br />
              *No spaces allowed. <br />
            </small>
          </div>
        </div>
      </div>
      <div *ngIf="isMobileView">
        <mat-checkbox class="clsGapping" formControlName="isNotificationEnabled" (change)="onChangeNotificationEnabled($event)"
          style="font-family: Verdana, Geneva, Tahoma, sans-serif;"> Notifications for new products.
        </mat-checkbox>

        <div class="row" *ngIf="form.controls['isNotificationEnabled'].value">
          <div class="col-md-6" style="margin-left: 30px;">
            <mat-checkbox formControlName="isPhone" (change)="onNotificationPreferenceChange()"> Phone</mat-checkbox>

            <mat-checkbox formControlName="isEmail" style="margin-left: 20px;" (change)="onNotificationPreferenceChange()"> Email </mat-checkbox>
          </div>
          <div class="col-md-6">
          </div>
        </div>
        <mat-checkbox class="clsGapping" style="font-family: Verdana, Geneva, Tahoma, sans-serif;"
          formControlName="isGetNotifiedWhenVideoGoesLive">Get notified when your purchased webinar goes live.
        </mat-checkbox>
        <mat-checkbox class="clsGapping" style="font-family: Verdana, Geneva, Tahoma, sans-serif;"
          formControlName="isAcceptTermsConditions">* I understand and accept all the <a
            routerLink="/TermConditions" style="color: blue !important;">Terms and
            Conditions</a> of this site. </mat-checkbox>
      </div>
      <div *ngIf="form.hasError('notificationPreferenceRequired') && form.controls['isNotificationEnabled'].value"
        style="color: #f44336; margin-left: 30px; margin-bottom: 10px; font-size: 12px;">
        Please select at least one notification preference (Email or Phone).
      </div>
      <div class="row">
        <div class="col-md-10">
        </div>
        <div class="col-md-2">
          <button (click)="RegisterUser()" class="clsBtn">Sign Up</button>

        </div>
      </div>
    </div>
  </form>
</div>